<template>
  <div>
    <base-header class="pb-9" type="danger"> </base-header>
    <modal :show.sync="showEditModal" size="lg" modal-classes="modal">
      <div class="p-4">
        <h4 class="mb-3">Edit live routing</h4>
        <div v-if="editingMatch" class="small text-muted mb-3">
          {{ editingMatch.team1Name }} vs {{ editingMatch.team2Name }}
        </div>
        <div class="row">
          <div class="col-md-6 mb-3">
            <div class="form-control-label">Input profile</div>
            <el-select
              v-model="editForm.inputId"
              class="w-100"
              clearable
              filterable
              placeholder="Select input profile"
            >
              <el-option
                v-for="inp in inputsEnabled"
                :key="inp.id"
                :label="inputOptionLabel(inp)"
                :value="inp.id"
              />
            </el-select>
          </div>
          <div class="col-md-6 mb-3">
            <div class="form-control-label">Takers</div>
            <el-select
              v-model="editForm.takerIds"
              class="w-100"
              filterable
              multiple
              collapse-tags
              placeholder="Select takers"
            >
              <el-option
                v-for="t in takersEnabled"
                :key="t.id"
                :label="t.name || t.key || t.id"
                :value="t.id"
              />
            </el-select>
          </div>
        </div>
        <div class="d-flex justify-content-end mt-2">
          <base-button type="secondary" class="mr-2" @click="showEditModal = false">
            Cancel
          </base-button>
          <base-button type="primary" :disabled="savingEdit" @click="saveRoutingEdit">
            Save
          </base-button>
        </div>
      </div>
    </modal>
    <div class="container-fluid mt--8">
      <div class="row">
        <div class="col">
          <div class="card shadow">
            <div class="card-header">
              <div class="h3 mb-0">Livestream Routing Admin</div>
            </div>
            <div class="card-body mb--4">
              <div class="row align-items-center">
                <div class="col-4">
                  <base-input class="select-danger">
                    <el-select
                      v-model="filters"
                      filterable
                      multiple
                      placeholder="Add filters"
                    >
                      <el-option
                        v-for="option in filterOptionArray"
                        :key="option.field"
                        class="select-danger"
                        :label="option.label"
                        :value="option.field"
                      />
                    </el-select>
                  </base-input>
                </div>
              </div>
              <div class="row align-items-center">
                <div class="col-4" v-for="filter in activeFilters" :key="filter">
                  <filter-selector
                    :selection="filterOptions[filter]"
                    @valueChange="filterValues[filter] = $event"
                  />
                </div>
                <div class="col-auto" v-if="activeFilters.length > 0">
                  <base-input>
                    <base-button @click="runQuery">Fetch</base-button>
                  </base-input>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="user.roles && user.roles.livestream_admin && selectedMatches.length > 0"
        class="row"
      >
        <div class="col">
          <div class="card shadow mb-3">
            <div class="card-header">
              <div class="h4 mb-0">Bulk live takers (matches)</div>
            </div>
            <div class="card-body">
        
              <div class="row align-items-end">
                <div class="col-md-4 mb-3">
                  <div class="form-control-label">Input profile</div>
                  <el-select
                    v-model="bulkSelectedInputId"
                    class="w-100"
                    clearable
                    filterable
                    placeholder="Select input profile"
                  >
                    <el-option
                      v-for="inp in inputsEnabled"
                      :key="inp.id"
                      :label="inputOptionLabel(inp)"
                      :value="inp.id"
                    />
                  </el-select>
                </div>
                <div class="col-md-4 mb-3">
                  <div class="form-control-label">Takers</div>
                  <el-select
                    v-model="bulkSelectedTakerIds"
                    class="w-100"
                    filterable
                    multiple
                    placeholder="Select taker profiles"
                  >
                    <el-option
                      v-for="t in takersEnabled"
                      :key="t.id"
                      :label="t.name || t.key || t.id"
                      :value="t.id"
                    />
                  </el-select>
                </div>
              </div>
              <base-button
                type="primary"
                :disabled="
                  selectedMatches.length === 0 ||
                  (bulkSelectedTakerIds.length === 0 && !bulkSelectedInputId) ||
                  bulkApplying
                "
                @click="bulkApplyTakers"
              >
                Apply to {{ selectedMatches.length }} match(es)
              </base-button>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <card class="no-border-card" body-classes="px-0 pb-1" footer-classes="pb-2">
            <el-table
              class="matchesTable"
              :data="matches"
              row-key="id"
              header-row-class-name="thead-light"
              :default-sort="{ prop: 'startDate', order: 'ascending' }"
              @selection-change="handleMatchSelectionChange"
            >
              <el-table-column
                v-if="user.roles && user.roles.livestream_admin"
                type="selection"
                width="48"
                reserve-selection
              />
              <el-table-column label="Home" prop="team1Name" min-width="120" />
              <el-table-column label="Away" prop="team2Name" min-width="120" />
              <el-table-column label="Date" prop="startDate" width="120" sortable>
                <template v-slot="{ row }">
                  {{ row.startDate | date }}
                </template>
              </el-table-column>
              <el-table-column label="Venue" prop="ground" min-width="130">
                <template v-slot="{ row }">
                  <venue-look-up :venueID="row.ground"></venue-look-up>
                </template>
              </el-table-column>
              <el-table-column label="Comp Name" prop="competitionName" min-width="140" sortable>
                <template v-slot="{ row }">
                  {{ row.competitionName || row.competition || "" }}
                </template>
              </el-table-column>
              <el-table-column label="Input" min-width="170">
                <template v-slot="{ row }">
                  <a
                    v-if="user.roles && user.roles.livestream_admin"
                    href="#"
                    class="routing-link"
                    @click.prevent="openEditRoutingModal(row)"
                  >
                    {{ inputNameForMatch(row) || "None" }}
                  </a>
                  <div v-else class="small text-muted">
                    {{ inputNameForMatch(row) || "None" }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="Takers" min-width="200">
                <template v-slot="{ row }">
                  <div class="mb-1">
                    <a
                      v-if="user.roles && user.roles.livestream_admin && !matchTakerRows(row).length"
                      href="#"
                      class="routing-link"
                      @click.prevent="openEditRoutingModal(row)"
                    >
                      None
                    </a>
                    <span v-else-if="!matchTakerRows(row).length" class="text-muted">None</span>
                    <a
                      v-for="r in matchTakerRows(row)"
                      :key="`${row.id}-${r.takerId}`"
                      href="#"
                      class="routing-link"
                      @click.prevent="openEditRoutingModal(row)"
                    >
                      {{ takerLabel(r.takerId) }}<span v-if="!isLastMatchTaker(row, r.takerId)">, </span>
                    </a>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="" width="110" align="right">
                <template v-slot="{ row }">
                  <router-link
                    class="btn btn-sm btn-outline-primary mb-0"
                    :to="{ name: 'Match Assets', params: { id: row.id }, query: { tab: 'live' } }"
                  >
                    Open Live
                  </router-link>
                </template>
              </el-table-column>
    
            </el-table>

            <div
              slot="footer"
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <div>
                <p class="card-category">
                  Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
                </p>
              </div>
              <base-pagination
                class="pagination-no-border"
                v-model="pagination.currentPage"
                :per-page="pagination.perPage"
                :total="total"
              />
            </div>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FilterSelector from "./Components/FilterSelector";
import VenueLookUp from "./Components/VenueLookUp";
import { Firebase } from "@/firebase.js";

export default {
  name: "LivestreamRoutingAdmin",
  components: {
    "venue-look-up": VenueLookUp,
    "filter-selector": FilterSelector,
  },
  data() {
    return {
      pagination: {
        perPage: 25,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
      selectedMatches: [],
      bulkSelectedTakerIds: [],
      bulkSelectedInputId: null,
      bulkTakerMode: "merge",
      bulkDefaultTakeBbcComms: true,
      bulkApplying: false,
      showEditModal: false,
      savingEdit: false,
      editingMatch: null,
      editForm: {
        inputId: null,
        takerIds: [],
      },
      requestedVenueIds: {},
      filters: [],
      filterValues: {},
      filterOptions: {
        year: { field: "year", label: "Year", type: "number" },
        cricketFormat: {
          field: "cricketFormat",
          label: "Format",
          collection: "matchFormats",
          collectionLabel: "name",
          collectionGetter: "formats",
          type: "single-select",
        },
        cricketType: {
          field: "cricketType",
          label: "Type",
          collection: "matchFormats",
          collectionLabel: "name",
          collectionGetter: "types",
          type: "single-select",
        },
        int: { field: "int", label: "International", type: "boolean" },
        teamsMap: {
          field: "teamsMap",
          collection: "teams",
          collectionLabel: "teamName",
          label: "Teams",
          type: "multi-select",
        },
        team1Name: {
          field: "team1Name",
          label: "Home Team",
          collection: "teams",
          collectionLabel: "teamName",
          collectionValue: "teamName",
          type: "single-select",
        },
        team2Name: {
          field: "team2Name",
          label: "Away Team",
          collection: "teams",
          collectionLabel: "teamName",
          collectionValue: "teamName",
          type: "single-select",
        },
        ground: {
          field: "ground",
          collection: "venues",
          collectionLabel: "name",
          label: "Venue",
          type: "single-select",
        },
      },
    };
  },
  computed: {
    user() {
      return this.$store.getters["user/user"];
    },
    matches() {
      return this.$store.getters["matches/array"];
    },
    filterOptionArray() {
      return Object.values(this.filterOptions);
    },
    activeFilters() {
      return (this.filters || []).filter((field) => !!this.filterOptions[field]);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) highBound = this.total;
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.matches.length;
    },
    takersEnabled() {
      const list = this.$store.getters["takers/array"] || [];
      return list.filter((t) => t && t.enabled !== false);
    },
    inputsEnabled() {
      const list = this.$store.getters["inputs/array"] || [];
      return list.filter((i) => i && i.id && i.enabled !== false);
    },
  },
  watch: {
    matches: {
      deep: true,
      immediate: true,
      handler(rows) {
        this.prefetchMissingVenues(rows || []);
      },
    },
    "user.roles": {
      deep: true,
      immediate: true,
      handler(roles) {
        if (roles && roles.livestream_admin) {
          this.$store.dispatch("takers/fetchAndAdd");
          this.$store.dispatch("inputs/fetchAndAdd");
        }
      },
    },
  },
  beforeMount() {
    this.$store.dispatch("teams/fetchAndAdd", { limit: 0 });
    this.$store.dispatch("venues/fetchAndAdd");

    const now = new Date();
    const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const where = [
      ["startDate", ">=", startOfToday],
    ];
    this.$store.dispatch("matches/fetchAndAdd", {
      clauses: { where, limit: 650 },
    });
  },
  methods: {
    sanitizeRoute(route) {
      if (!route || !route.takerId) return null;
      const clean = {
        takerId: route.takerId,
        takeBbcComms: route.takeBbcComms !== false,
        enabled: route.enabled !== false,
      };
      if (route.sortOrder !== undefined && route.sortOrder !== null) {
        const parsed = Number(route.sortOrder);
        if (!Number.isNaN(parsed)) clean.sortOrder = parsed;
      }
      return clean;
    },
    buildTakerRoute(takerId, sortOrder, defaultTakeBbcComms = true) {
      return this.sanitizeRoute({
        takerId,
        enabled: true,
        sortOrder,
        takeBbcComms:
          this.$store.getters["takers/byId"](takerId)?.bbcAudioAllowed !== undefined
            ? this.$store.getters["takers/byId"](takerId).bbcAudioAllowed !== false
            : this.$store.getters["takers/byId"](takerId)?.defaultTakeBbcComms !== undefined
              ? this.$store.getters["takers/byId"](takerId).defaultTakeBbcComms !== false
              : defaultTakeBbcComms !== false,
      });
    },
    buildNextRoutes(existingRoutes, takerIds, mode, defaultTakeBbcComms = true) {
      if (!Array.isArray(takerIds)) return null;
      if (!takerIds.length) {
        return mode === "replace" ? [] : null;
      }
      const incoming = takerIds
        .map((takerId, index) => this.buildTakerRoute(takerId, index + 1, defaultTakeBbcComms))
        .filter(Boolean);
      if (mode === "replace") return incoming;

      const byId = new Map(
        (Array.isArray(existingRoutes) ? existingRoutes : [])
          .map((r) => this.sanitizeRoute(r))
          .filter(Boolean)
          .map((r) => [r.takerId, r])
      );
      incoming.forEach((row) => {
        const prev = byId.get(row.takerId) || {};
        byId.set(row.takerId, {
          ...prev,
          ...row,
          // Preserve existing sort order for existing rows on merge.
          sortOrder: prev.sortOrder !== undefined ? prev.sortOrder : row.sortOrder,
        });
      });
      return Array.from(byId.values()).map((r) => this.sanitizeRoute(r)).filter(Boolean);
    },
    buildMatchRoutingPatch(row, { takerIds, livestreamInputId, includeInput, mode, defaultTakeBbcComms }) {
      if (!row || !row.id) return null;
      const patch = {};
      const nextRoutes = this.buildNextRoutes(
        row.livestreamTakerRoutes,
        Array.isArray(takerIds) ? takerIds : [],
        mode,
        defaultTakeBbcComms
      );
      if (Array.isArray(nextRoutes)) {
        patch.livestreamTakerRoutes = nextRoutes;
      }
      if (includeInput) {
        patch.livestreamInputId = livestreamInputId;
      }
      return Object.keys(patch).length ? patch : null;
    },
    async patchMatchRouting(row, { takerIds, livestreamInputId, includeInput, mode, defaultTakeBbcComms }) {
      if (!row || !row.id) return false;
      const patch = this.buildMatchRoutingPatch(row, {
        takerIds,
        livestreamInputId,
        includeInput,
        mode,
        defaultTakeBbcComms,
      });
      if (!patch) return false;
      await this.$store.dispatch("matches/patch", { id: row.id, ...patch });
      await this.$store.dispatch("matches/fetchById", row.id);
      return true;
    },
    prefetchMissingVenues(rows) {
      (rows || []).forEach((row) => {
        const venueId = row && row.ground;
        if (!venueId) return;
        const venue = this.$store.getters["venues/byId"](venueId);
        if (venue) return;
        if (this.requestedVenueIds[venueId]) return;
        this.$set(this.requestedVenueIds, venueId, true);
        this.$store.dispatch("venues/fetchById", venueId).catch(() => {});
      });
    },
    openEditRoutingModal(row) {
      if (!row || !row.id) return;
      this.editingMatch = row;
      this.editForm = {
        inputId: row.livestreamInputId || null,
        takerIds: this.matchTakerRows(row).map((r) => r.takerId),
      };
      this.showEditModal = true;
    },
    async saveRoutingEdit() {
      if (!this.editingMatch || !this.editingMatch.id || this.savingEdit) return;
      this.savingEdit = true;
      try {
        const desiredInputId = this.editForm.inputId ? String(this.editForm.inputId).trim() : null;
        await this.patchMatchRouting(this.editingMatch, {
          takerIds: Array.isArray(this.editForm.takerIds) ? this.editForm.takerIds : [],
          livestreamInputId: desiredInputId,
          includeInput: true,
          mode: "replace",
          defaultTakeBbcComms: true,
        });
        this.showEditModal = false;
      } catch (e) {
        console.error(e);
        window.alert(e.message || "Save failed");
      } finally {
        this.savingEdit = false;
      }
    },
    matchTakerRows(row) {
      if (!row || !Array.isArray(row.livestreamTakerRoutes)) return [];
      return row.livestreamTakerRoutes.filter((r) => r && r.takerId && r.enabled !== false);
    },
    takerLabel(takerId) {
      const t = this.$store.getters["takers/byId"](takerId);
      return (t && (t.name || t.key)) || takerId;
    },
    inputOptionLabel(inp) {
      const type =
        inp.type === "mediaconnect"
          ? "MC"
          : inp.type === "medialive"
            ? "ML"
            : inp.type === "brightcove"
              ? "BC"
              : inp.type || "?";
      return `${inp.name || inp.id} [${type}]`;
    },
    inputNameForMatch(row) {
      if (!row || !row.livestreamInputId) return "";
      const input = this.$store.getters["inputs/byId"](row.livestreamInputId);
      if (!input) return row.livestreamInputId;
      return this.inputOptionLabel(input);
    },
    defaultTakeBbcCommsForTaker(takerId) {
      const t = this.$store.getters["takers/byId"](takerId);
      if (!t) return true;
      if (t.bbcAudioAllowed !== undefined) return t.bbcAudioAllowed !== false;
      if (t.defaultTakeBbcComms !== undefined) return t.defaultTakeBbcComms !== false;
      return true;
    },
    isLastMatchTaker(row, takerId) {
      const ids = this.matchTakerRows(row).map((r) => r.takerId);
      return ids[ids.length - 1] === takerId;
    },
    handleMatchSelectionChange(rows) {
      this.selectedMatches = rows || [];
    },
    async bulkApplyTakers() {
      if (!this.selectedMatches.length) return;
      if (!this.bulkSelectedTakerIds.length && !this.bulkSelectedInputId) return;
      if (this.bulkTakerMode === "replace" && this.bulkSelectedTakerIds.length) {
        const ok = window.confirm(
          `Replace will overwrite livestreamTakerRoutes on ${this.selectedMatches.length} match(es). Continue?`
        );
        if (!ok) return;
      }
      this.bulkApplying = true;
      try {
        const desiredInputId = this.bulkSelectedInputId ? String(this.bulkSelectedInputId).trim() : null;
        const chunkSize = 400;
        let updated = 0;
        for (let i = 0; i < this.selectedMatches.length; i += chunkSize) {
          const chunk = this.selectedMatches.slice(i, i + chunkSize);
          const batch = Firebase.firestore().batch();
          const changedIds = [];
          chunk.forEach((row) => {
            const patch = this.buildMatchRoutingPatch(row, {
              takerIds: this.bulkSelectedTakerIds,
              livestreamInputId: desiredInputId,
              includeInput: true,
              mode: this.bulkTakerMode,
              defaultTakeBbcComms: this.bulkDefaultTakeBbcComms,
            });
            if (!patch) return;
            batch.update(Firebase.firestore().collection("matches").doc(row.id), patch);
            changedIds.push(row.id);
          });
          if (!changedIds.length) continue;
          await batch.commit();
          updated += changedIds.length;
          await Promise.all(changedIds.map((id) => this.$store.dispatch("matches/fetchById", id)));
        }
        window.alert(`Updated ${updated} match(es).`);
      } catch (e) {
        console.error(e);
        window.alert(e.message || "Bulk apply failed");
      } finally {
        this.bulkApplying = false;
      }
    },
    runQuery() {
      this.$store.commit("matches/RESET_VUEX_EASY_FIRESTORE_STATE");
      const where = [];
      this.activeFilters.forEach((field) => {
        const value = this.filterValues[field];
        const option = this.filterOptions[field];
        if (value === undefined || value === null || value === "") return;

        if (option.type === "single-select" || option.type === "boolean") {
          where.push([field, "==", value]);
        } else if (option.type === "multi-select" && Array.isArray(value)) {
          value.forEach((v) => where.push([`${field}.${v}`, "==", true]));
        } else if (option.type === "number") {
          where.push([field, "==", parseInt(value, 10)]);
        } else if (option.type === "text") {
          where.push([field, "==", value]);
        }
      });

      this.$store.dispatch("matches/fetchAndAdd", {
        clauses: { where, limit: 250 },
      });
    },
  },
};
</script>

<style>
.el-table__expand-column {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.select-danger .el-select .el-tag {
  background: #f5365c;
}

.routing-link {
  font-size: inherit;
  font-weight: inherit;
}
</style>
